import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import { useState } from 'react';
import zeplinColor from 'theme/Color';

const StageChangeModal = ({
  isOpen,
  handleClose,
  stages,
  handledSelectStage,
}: {
  isOpen: boolean;
  handleClose: () => void;
  stages: string[];
  handledSelectStage: (cancel: boolean, stage?: string) => void;
}) => {
  const [selectedStage, setSelectedStage] = useState(stages[0]);

  const handleStageSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedStage(event.target.value);
  };

  return (
    <CustomModal handleClose={handleClose} open={isOpen}>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CustomCard
          styles={{
            borderRadius: '14px',
            padding: '24px',
            backgroundColor: zeplinColor.Neutral1,
            width: '400px',
            boxShadow: 'rgba(0, 0, 0, 0.15)',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: '18px', xl: '24px' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                Confirm New Stage
              </Typography>
              <img
                src={'/assets/cross.svg'}
                alt='close'
                onClick={handleClose}
                style={{ cursor: 'pointer' }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '10px', xl: '16px' },
              }}
            >
              <Typography variant='responsiveBody3' color={zeplinColor.BasicBlack}>
                This column supports multiple stages. Please select the specific stage for this
                deal.
              </Typography>
              <RadioGroup
                aria-labelledby='task-type-radio-group'
                name='task-type-radio-group'
                value={selectedStage}
                onChange={handleStageSelection}
                sx={{
                  color: zeplinColor.BasicBlack,
                  '&.Mui-checked': {
                    color: zeplinColor.BasicBlack,
                  },
                  padding: '0px',
                }}
              >
                {stages.map((item) => (
                  <FormControlLabel
                    key={item}
                    value={item}
                    control={
                      <Radio
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                    }
                    label={item}
                    sx={{
                      padding: '0px',
                      color: zeplinColor.BasicBlack,
                      '& .MuiButtonBase-root': {
                        color: zeplinColor.BasicBlack,
                      },
                    }}
                  />
                ))}
              </RadioGroup>
            </Box>

            <Box
              sx={{
                display: 'inline-flex',
                gap: '24px',
              }}
            >
              <CustomButton
                disabled={false}
                onClick={() => handledSelectStage(true)}
                variant='outlined'
                buttonVariant='buttonMedium'
                style={{
                  width: '100%',
                  borderRadius: '14px',
                  height: 48,
                  padding: '14px 16px',
                  backgroundColor: zeplinColor.Neutral1,
                  borderColor: zeplinColor.BasicBlack,
                  color: zeplinColor.BasicBlack,
                }}
                text={'Cancel'}
              />

              <CustomButton
                disabled={false}
                onClick={() => handledSelectStage(false, selectedStage)}
                variant='contained'
                buttonVariant='buttonMedium'
                color={'primary'}
                style={{
                  width: '100%',
                  whiteSpace: 'nowrap',
                  borderRadius: '14px',
                  height: 48,
                  padding: '14px 16px',
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={'Confirm Update'}
              />
            </Box>
          </Box>
        </CustomCard>
      </Box>
    </CustomModal>
  );
};

export default StageChangeModal;
